<template>
    <div class="report-total-score-light text-center"
         v-if="participantScores && scoreDef">

        <b-badge :v-if="risk"
                 :variant="risk ? risk.variant : null">
            {{ risk ? $i18n.gt(risk.label) : null }}
        </b-badge>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import ReportMixin from '@/providers/ReportMixin'

    /**
     * Displays a color-coded light based on the overall risk score
     */
    export default Vue.extend({
        name: 'report-total-score-light',
        mixins: [ReportMixin],
        computed: {
            participantScores () {
                return this.$store.state.patientParticipant.latestScoreDefs
            },
            scoreDef () {
                return this.$store.state.patientParticipant.latestScoreDefs['TOTAL_SCORE']
            },
            risk () {
                if (!this.scoreDef) {
                    return null
                } else {
                    const level = this.scoreDef.threshold_index

                    if (level == 3) {
                        return { variant: 'danger', label: 'LABEL_GAUGE_VERY_HIGH_RISK' }
                    } else if (level == 2) {
                        return { variant: 'warning', label: 'LABEL_GAUGE_HIGH_RISK' }
                    } else if (level == 1) {
                        return { variant: 'info', label: 'LABEL_GAUGE_INCREASED_RISK' }
                    } else {
                        return { variant: 'light', label: 'LABEL_GAUGE_LOW_RISK' }
                    }
                }
            }
        }
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
</style>

